import {createGlobalStyle} from 'styled-components';

const GlobalStyles = createGlobalStyle`
    
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        scroll-behavior: smooth;
    }

    body {
        font-family: 'Poppins', sans-serif;
        background-color: #fdf5e6;
        color: #807d7d;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    ul {
        list-style: none;
    }

    button {
        cursor: pointer;
    }

    p {
        font-size: 1.1rem;
        color: #807d7d;
        line-height: 1.6;
    }

    .container {
        width: 100%;
        max-width: 1600px; 
        margin: 0 auto; 
        padding: 0 1.5rem;

        @media (max-width: 1280px) {
            max-width: 95%;
        }

        @media (max-width: 1024px) {
            max-width: 95%;
        }

        @media (max-width: 768px) {
            max-width: 100%;
            padding: 0 1rem;
        }
    }

    .featured {
        max-width: 1200px;
    }

    .section-title {
        font-size: 42px;
        margin-bottom: 1rem;
        margin-top: 4rem;
        font-family: 'Dancing Script', cursive;
        color: #4a3a29;
        text-align: center;
    }

    .section-border {
        width: 100px;
        height: 3px;
        background-color: #b31a1a;
        margin: 0 auto 3rem;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
`;

export default GlobalStyles;